// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3T5br","title":"AfterImages90_title__XCZ0E","images":"AfterImages90_images__etkcO"};